import React, { useState, useEffect } from 'react';
import  { useNavigate, useLocation } from 'react-router-dom'

import iconWarningTriangle from '../images/error/warning_triangle.png'

function ErrorPage() {

  const navigate = useNavigate();
  const { state } = useLocation()
  const [ goPath, setGoPath ] = useState('/')

  useEffect(() => {
    if(state?.goPath){
      setGoPath(state.goPath)
    }
  }, [])

  function gotoPage(){
    navigate(goPath, { replace: true })
  }

  return (
  <div className="flex-wrap w-full  h-full min-h-screen   md:px-[120px] font-prompt py-4 px-2 ">
      <div className="flex w-full  flex-wrap  justify-center pb-12  h-screen flex items-center justify-center">
        <div className="flex flex-wrap w-full  lg:w-[974px]   bg-white rounded-xl ">
          <div className='flex-wrap flex w-full'>
            <div className=" flex-wrap w-full   p-6 md:py-6   px-4 md:px-6  flex justify-center  ">
              <div className='flex w-full justify-center'>
                <img src={iconWarningTriangle} alt="icon-success" className='w-[48px] h-[48px]' />
              </div>
              <div className='flex flex-wrap w-full  justify-center'>
                <span className='w-full mt-[24px] text-[16px] font-medium  text-black  text-center  '>ไม่สามารถดำเนินการได้ในขณะนี้</span>
                <span className='w-full mt-[4px] text-[14px] text-[#666] font-normal leading-5 text-center text-black '>กรุณาทำรายการใหม่ในภายหลัง หากมีข้อสงสัย <br/>กรุณาติดต่อฝ่ายลูกค้าสัมพันธ์ โทร. 1231 กด 4</span>
                <button 
                      onClick={gotoPage} 
                      className={'mt-[24px]  py-[10px] px-[16px] text-[14px] text-base font-medium border border-grey-300  rounded-lg border-radius-other bg-white text-black '}>
                        ลองใหม่
                  </button>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
  )
}

export default ErrorPage;